import React from "react";
import { Modal, Col, Row } from "react-bootstrap";

import W1 from "../../images/icons/whatsapp-gris.png";
import W2 from "../../images/icons/whatsapp-azul.png";
import E1 from "../../images/icons/correo-gris.png";
import E2 from "../../images/icons/correo-azul.png";

export default function ModalCita({show, onHide}) {

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
            <Row xs={12}>
                <Col lg={6} md={6} xs={6} className="pb-2">
                <a
                    href="https://wa.me/+5218116001600"
                    target="_blank"
                    rel="noreferrer"
                >
                    <img
                    src={W1}
                    alt="Icono Whatsapp Agencia Chevrolet Monterrey"
                    onMouseOver={(e) => (e.currentTarget.src = W2)}
                    onMouseOut={(e) => (e.currentTarget.src = W1)}
                    onFocus={(e) => (e.currentTarget.src = W2)}
                    onBlur={(e) => (e.currentTarget.src = W1)}
                    width="100%"
                    style={{ cursor: "pointer" }}
                    />
                </a>
                </Col>
                {/*<Col lg={4} md={4} xs={4} className="pb-2">
                <a href="tel:8112571257" rel="noreferrer" target="_blank">
                    <img
                    src={L1}
                    alt="Icono Llamar Agencia Chevrolet Monterrey"
                    onMouseOver={(e) => (e.currentTarget.src = L2)}
                    onMouseOut={(e) => (e.currentTarget.src = L1)}
                    onFocus={(e) => (e.currentTarget.src = L2)}
                    onBlur={(e) => (e.currentTarget.src = L1)}
                    width="100%"
                    style={{ cursor: "pointer" }}
                    />
                </a>
        </Col>*/}
                {/*<Col lg={3} md={3} xs={6} className="pb-2">
                <div
                    id="chat-salesforce-btn"
                    data-metakey="mobile-btn-chat"
                    onClick={(e) => handleKeyPress(e)}
                >
                    <img
                    src={C1}
                    alt="Icono Chatear Agencia Chevrolet Monterrey"
                    onMouseOver={(e) => (e.currentTarget.src = C2)}
                    onMouseOut={(e) => (e.currentTarget.src = C1)}
                    onFocus={(e) => (e.currentTarget.src = C2)}
                    onBlur={(e) => (e.currentTarget.src = C1)}
                    width="100%"
                    style={{ cursor: "pointer" }}
                    />
                </div>
            </Col>*/}
                <Col lg={6} md={6} xs={6} className="pb-2">
                <a
                    href="mailto:informes@gruporivero.com"
                    rel="noreferrer"
                    target="_blank"
                >
                    <img
                    src={E1}
                    alt="Icono Correo Agencia Chevrolet Monterrey"
                    onMouseOver={(e) => (e.currentTarget.src = E2)}
                    onMouseOut={(e) => (e.currentTarget.src = E1)}
                    onFocus={(e) => (e.currentTarget.src = E2)}
                    onBlur={(e) => (e.currentTarget.src = E1)}
                    width="100%"
                    style={{ cursor: "pointer" }}
                    />
                </a>
                </Col>
            </Row>
            </Modal.Body>
        </Modal>
    );
}
